import { render, staticRenderFns } from "./HomePage.component.pug?vue&type=template&id=1f5b41d8&scoped=true&lang=pug&"
import script from "./HomePage.component.ts?vue&type=script&lang=ts&"
export * from "./HomePage.component.ts?vue&type=script&lang=ts&"
import style0 from "./HomePage.component.scss?vue&type=style&index=0&id=1f5b41d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b41d8",
  null
  
)

export default component.exports